import { Typography } from '@mui/material';
import React from 'react';
import { useAttributeStyles } from 'components/Modals/QCPassFailModal/styles';

export const AttributeLabel = ({ label, value }) => {
  const { classes } = useAttributeStyles();

  if (!value) {
    return null;
  }

  return (
    <div className={classes.marginBottom05RemStyle}>
      <Typography className={classes.inlineBlockNormalStyle}>
        {' '}
        {label}
        {' : '}
      </Typography>{' '}
      <Typography className={classes.inlineBlockBoldStyle}>{value}</Typography>
    </div>
  );
};
